import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, RefreshCcw } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Cancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F5F6F6]">
      <Header />
      <main className="max-w-2xl mx-auto px-6 lg:px-8 py-20 text-center" data-testid="cancel-page">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-[#373A45]">
          Plata a fost anulată
        </h1>
        <p className="mt-3 text-[#6B7280]">
          Nu s-a efectuat nicio tranzacție. Poți relua oricând procesul de înscriere.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate("/checkout")}
            className="rounded-full bg-[#965EA7] hover:bg-[#7A4986] text-white font-semibold px-6 py-3 inline-flex items-center justify-center gap-2"
            data-testid="cancel-retry"
          >
            <RefreshCcw size={16} /> Reia plata
          </button>
          <Link
            to="/"
            className="rounded-full border-2 border-[#373A45] text-[#373A45] font-semibold px-6 py-3 inline-flex items-center justify-center gap-2 hover:bg-[#373A45] hover:text-white"
            data-testid="cancel-home"
          >
            <ArrowLeft size={16} /> Înapoi la pagina principală
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
